var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTreestructure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "15px",
    viewBox: "0 0 20 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Combined Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Tree-Testing_White-Version",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Analysis-1st-click-&-destination-1",
    transform: "translate(-252.000000, -421.000000)",
    fill: "#383838"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(252.000000, 421.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,5.24691401e-13 L20,5.24691401e-13 L20,3.92727273 L0,3.92727273 L0,5.24691401e-13 Z M4.8,5.23636364 L20,5.23636364 L20,9.16363636 L4.8,9.16363636 L4.8,5.23636364 Z M10.4,10.4727273 L20,10.4727273 L20,14.4 L10.4,14.4 L10.4,10.4727273 Z",
    id: "Combined-Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreestructure);
export default __webpack_public_path__ + "static/media/treestructure.2c939f7f7f4150285484b717c0dcb48a.svg";
export { ForwardRef as ReactComponent };